import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Spinner from '../Utils/Spinner';
import VideoPlayer from '../VideoPlayer';
import AppContext from '../Context/AppContext';
import Episodes from './Episodes';
import Header from '../Main/Header';

const SeriesPlayer = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const ctx = useContext(AppContext);
    const params = useParams();
    const watchId = params.watchId;
    const season = params.season;
    const episode = params.episode;

    const [data, setData] = useState();
    const [error, setError] = useState();
    const sourceRef = useRef();
    const [source, setSource] = useState('0');

    const url = ctx.apiUrl + '/api/season/' + watchId + '?s=' + season + '&e=' + episode;
    useEffect(() => {
        axios
            .get(url)
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : error.message;
                setError(errorMessage);
            });
    }, [episode]);

    const changeSource = () => {
        setSource(sourceRef.current.value);
    };

    return (
        <>
            <Header />
            {data && (
                <div className='h-screen w-screen relative'>
                    <p className='text-sm font-medium text-center p-1'>{searchParams.get('title')}</p>
                    <p className='text-xs text-center p-1'>
                        S {season} ~ E {episode}
                    </p>

                    <div className='flex flex-col items-center'>
                        <div className='flex flex-col space-y-1 items-center w-full md:w-3/5'>
                            {source === '0' && <VideoPlayer video={data.sources[0]} track={data.track} />}
                            {source === '1' && <VideoPlayer video={data.sources[1]} track={data.track} />}
                            {source === '2' && <VideoPlayer video={data.sources[2]} track={data.track} />}
                            {source === '3' && <VideoPlayer video={data.sources[3]} track={data.track} />}

                            <div className='form-contol'>
                                <select className='select select-sm w-28' ref={sourceRef} onChange={changeSource}>
                                    <option value='0'>Auto</option>

                                    <option value='1'>360p</option>
                                    <option value='2'>720p</option>
                                    <option value='3'>1080p</option>
                                </select>
                            </div>

                            <a
                                className='btn btn-sm btn-solid-primary'
                                href={data.sources[0]}
                                target='_blank'
                                rel='noreferrer'
                            >
                                Download
                            </a>
                        </div>
                    </div>
                    <div className='divider divider-horizontal'></div>
                    <Episodes />
                </div>
            )}
            {!data && !error && (
                <div className='h-screen w-screen overflow-hidden flex justify-center items-center'>
                    <div className='flex items-center space-x-2'>
                        <Spinner className='spinner-sm' /> <span>Loading</span>
                    </div>
                </div>
            )}
            {error && (
                <div className='h-screen bg-backgroundSecondary w-screen overflow-hidden flex justify-center items-center'>
                    <div className='flex items-center space-x-2'>
                        <span className='text-error'>{error}</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default SeriesPlayer;
